<template>
    <div id="ProgramAssetMapperList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Program Asset List</div>
                    <div class="web-action-btn">
                        <div class="btn-groups">
                            <router-link class="btn btn-primary" v-bind:to="{name: 'ProgramChildList',params:{id:$route.params.id}}" > Child Program</router-link>
                            <button id="addActivitytBtn" v-on:click.prevent="addActivity()" class="btn btn-primary">Add Activity</button>
                            <button id="addAssetBtn" v-on:click.prevent="addAsset('asset')" class="btn btn-primary">Add Asset</button>
                            <button id="addAssetGroupBtn" v-on:click.prevent="addAsset('group')" class="btn btn-primary">Add Asset Group</button>
                            <router-link class="btn btn-secondary" v-bind:to="{name: 'ProgramList'}" > <i class="fp-back"> </i> Back</router-link>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content program-asset-list">
                        <div class="form-row section-divider">
                                <div class="col-md-3">
                                    <div class="row form-group">
                                        <label class="col">Program Name:</label>
                                        <span class="col"> {{ name }} </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="row form-group">
                                        <label class="col">Description:</label>
                                        <span class="col"> {{ description }} </span>
                                    </div>
                                </div>
                            </div>
                        <data-table-filter-config :moduleName="'programAssetList'" :allowSameFilter="'allow'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <div class="btn-groups">
                            <button id="LoadAssetBtn" v-on:click.prevent="loadListAsset('asset')" class="btn btn-primary">By Asset</button>
                            <button id="loadAssetGroupWise" v-on:click.prevent="loadListAsset('group')" class="btn btn-primary">By Asset Group</button>
                        </div>
                            &nbsp;&nbsp;
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'programAssetList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listProgramAssetTable"
                                    mode="remote"
                                    title="Program Asset"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateProgram">
                                                    <!-- <router-link title="Edit Program" class="fp-edit" v-bind:to="{name: 'ProgramEdit',params:{id:props.row.id}}"></router-link> -->
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <!-- <button id="addAssetBtn" v-on:click.prevent="addAsset('asset')" class="btn btn-primary">Add Asset</button> -->
                                        <!-- <button id="addAssetBtn" v-on:click.prevent="addAsset('group')" class="btn btn-primary">Add Asset Group</button> -->
                                        <button id="addProgramIntervalBtn" v-on:click.prevent="loadPrograms" class="btn btn-primary">Add Interval</button>
                                        <button id="deleteProgramAssetBtn" v-on:click.prevent="programAssetDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                    <div class="modal fade program-interval-modal" id="program-interval-modal" ref="programIntervalModal" data-backdrop="static" data-keyboard="false" aria-labelledby="programIntervalModal" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Interval</h5>
                                </div>
                                <div class="modal-body">
                                        <div v-if="introws && introws.length > 0" class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col" class="require">Interval Type</th>
                                                    <th scope="col" :class="requireFrom">From Value</th>
                                                    <th scope="col" :class="requireTo">To Value</th>
                                                    <th scope="col" :class="requireUOM" class='w-25'>UOM</th>
                                                    <th scope="col">Metric</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(read, index) in introws" :key="index">
                                                    <td>
                                                        <v-select class="section-id" id ="interval_type" v-model="read.interval_type" name="interval_type" placeholder="Select Interval"
                                                            label="text" @input="onIntervalSelect($event)"
                                                            :options="intervalTypeArr">
                                                        </v-select>
                                                        <div class="field-error">{{ read.interval_type_error_msg }}</div>
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control" v-model="read.from_value" id="from_value" @keypress="isNumber($event)" placeholder="Enter From Value" name="from_value">
                                                        <div class="field-error">{{ read.from_value_error }}</div>
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control" v-model="read.to_value" id="to_value" @keypress="isNumber($event)" placeholder="Enter To Value" name="to_value">
                                                        <div class="field-error">{{ read.to_value_error }}</div>
                                                    </td>
                                                    <td>
                                                        <v-select class="section-id" v-model="read.uom_id" name="uom_id" @input="onChangeUOM($event,read.uom_id,index)" placeholder="Select UOM"
                                                            label="text"
                                                            :options="vomArr">
                                                        </v-select>
                                                        <div class="field-error">{{ read.uom_error }}</div>
                                                    </td>
                                                    <td>
                                                        <span>{{read.metric}}</span>
                                                    </td>
                                                    <td class="text-center valign-middle">
                                                        <template v-if="introws.length != 1">
                                                            <a href="javascript:void(0)" v-on:click.prevent="removeElement(index);"> <i class="fp-remove"></i> </a>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> _ </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="btn-groups">
                                            <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                                <i class="fp-add"></i> Add Line Item
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="submit" id="createProgramBtn" class="btn btn-primary" v-on:click.prevent="createProgram" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="button" class="btn btn-tertiary" id="cancelProgramBtn" v-on:click="hideModal()"> <i class="fp-close"></i>Cancel </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ProgramList",
        metaInfo() {
            return {title: "Program Asset List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins,contractMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     hidden:false,
                //     sortable: false,
                // },
                 {
                    label: 'Asset',
                    field: 'unit_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Asset Group',
                    field: 'group',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Group", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Asset',
                //     field: 'vehicle_name',
                //     filterable: true,
                //     fpFieldType:"text",
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Name", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Asset Type ',
                    field: 'vehicle_type',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Trigger Date',
                    field: 'trigger_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Trigger Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Next Trigger From Date',
                    field: 'next_trigger_from',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Next Trigger From Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Manufacturer',
                    field: 'manufacturer',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Model',
                    field: 'model',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            term_value: false,
            loading:false,
            canUpdateProgram:false,
            canAddProgram:false,
            activeFlag:'asset',
            description:'',
            name:'',
            action:'list',
            introws:[],
            vomArr:[],
            requireUOM:'',
            requireFrom:'',
            requireTo:'',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_program') {
                            self.cantAccessPage = true;
                        }
                        // if (permissions[i].name == 'delete_Program') {
                        //     self.term_value = true;
                        // }
                        if (permissions[i].name == 'add_program') {
                            self.canAddProgram = true;
                            self.canUpdateProgram = true;
                        }
                        // if (permissions[i].name == 'add_asset_type') {
                        //     self.cantAccessPage = true;
                        // }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            self.loadFieldData(['selectedmeasurementUnit','priority']);

            //self.loadList();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listProgramAssetTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            loadListAsset:function(flag){
                var self = this;
                self.activeFlag = flag;
                self.loadList();
            },

            loadList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                var data = this.$refs['listProgramAssetTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listProgramAssetTable'].selectedRows[i].id)
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    id:segments[3],
                    flag:self.activeFlag,
                    action:self.action,
                    selectedRows:selectedRows,
                };
                self.firstLoad = 1;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/program-asset/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                             if ( self.action == "delete" ) {
                                self.action = "list";
                                self.loadList();

                            }else{
                                self.name = data.content.name;
                                self.description = data.content.description;
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                if (self.activeFlag == 'group'){
                                    for( var i=0; i<self.userColumns.length; i++ ) {
                                        if ( self.userColumns[i].field == 'unit_no' ) {
                                            self.$set(self.userColumns[i], 'hidden', true)
                                        }
                                    }
                                }else{
                                    for( var i=0; i<self.userColumns.length; i++ ) {
                                        if ( self.userColumns[i].field == 'unit_no' ) {
                                            self.$set(self.userColumns[i], 'hidden', false)
                                        }
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-asset-list')
                    }
                });
            },

            addAsset:function(flag){
                var self = this;
                var id = self.$route.params.id;
                if (flag == 'asset'){
                    self.$router.push("/asset/list?from=program&pr="+id);
                }
                if (flag == 'group'){
                    self.$router.push("/assetgroup/list?from=program&pr="+id);
                }
            },

            programAssetDelete() {
              var self = this;
              self.$swal({
                    title: 'Are you sure that you want to delete this Mapping?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      this.action = "delete";
                      this.loadList();

                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Mapping? ')) {
                //     this.action = "delete";
                //     // $("#deleteRentalAgreementBtn").val("Deleting ...");

                //     this.loadList();
                // }

            },

            addActivity:function(){
                var self = this;
                var id = self.$route.params.id;
                self.$router.push("/program-activity/create/"+id);
            },
            addRow: function () {

                var self = this;
                var i = self.introws.length - 1;
                var error = false;
                self.introws[i].interval_type_error_msg = "";
                self.introws[i].from_value_error = "";
                self.introws[i].to_value_error = "";
                self.introws[i].uom_error = "";

                if (self.introws[i].interval_type != null && self.introws[i].interval_type != '' && self.introws[i].interval_type.value &&  self.introws[i].interval_type.value == 'o') {

                        self.introws.push({
                            interval_id:0,
                            interval_type: '',
                            interval_type_error_msg:'',
                            from_value: '',
                            to_value:'',
                            from_value_error:'',
                            to_value_error:'',
                            uom_error:'',
                            uom_id:'',
                            metric:'',
                        });

                } else {
                    if (self.introws[i].interval_type == null || self.introws[i].interval_type == '' || !self.introws[i].interval_type) {
                        self.introws[i].interval_type_error_msg = "Interval Type is Required.";
                        error = true;
                    }

                    if (self.introws[i].interval_type != null && self.introws[i].interval_type != '' && self.introws[i].interval_type.value && self.introws[i].interval_type.value != 'o') {

                        if (self.introws[i].from_value == null || self.introws[i].from_value == ''){
                            self.introws[i].from_value_error = "From Value is Required.";
                            error = true;
                        }

                        if (self.introws[i].to_value == null || self.introws[i].to_value == ''){
                            self.introws[i].to_value_error = "To Value is Required.";
                            error = true;
                        }

                    }
                    if (self.introws[i].interval_type != null && self.introws[i].interval_type != '' && self.introws[i].interval_type.value && self.introws[i].interval_type.value == 'm') {

                        if (self.introws[i].uom_id == null || self.introws[i].uom_id == ''){
                            self.introws[i].uom_error = "UOM Required.";
                            error = true;
                        }
                    }

                    if (!error){
                        self.introws.push({
                            interval_id:0,
                            interval_type: '',
                            interval_type_error_msg:'',
                            from_value: '',
                            to_value:'',
                            from_value_error:'',
                            to_value_error:'',
                            uom_error:'',
                            uom_id:'',
                            metric:'',
                        });
                    }
                }
            },
            removeElement: function (index) {
                var self = this;

            if (self.introws.length > 1) {
                    if (self.introws[index].interval_id == 0) {
                        self.introws.splice(index, 1);

                    } else {
                        if (confirm('Are you sure that you want to delete this Interval? ')) {
                            $.ajax({
                                url: process.env.ROOT_API + "/program-interval/delete",
                                type: "POST",
                                data: {
                                    'id': self.introws[index].interval_id
                                },
                                headers: this.ajxHeaders,
                                dataType: "json",
                                success: function (data) {
                                    if (data.status == "success") {
                                        self.introws.splice(index, 1);
                                    }

                                },
                                error: function (jqXHR, exception) {
                                    self.generateStatusCodeMessage(jqXHR,true,'program-interval-delete-item')
                                },
                            });
                        }
                    }
                }
            },
            onChangeUOM:function(evt,uom,index){
                var self = this;
                console.log(uom);
                if (uom.symbol && uom.symbol == 'MLS'){
                    self.introws[index].metric = 'DIST';
                }
                if (uom.symbol && uom.symbol == 'HRS'){
                    self.introws[index].metric = 'HOUR';
                }
            },
            titleCase(str) {
                if ( str == null ) {
                    return "-";
                } else {
                    var value = str.toString();
                    return value.charAt(0).toUpperCase() + value.slice(1);
                }
            },
            onIntervalSelect(event) {
                var self = this;
                for (var i = 0; i < self.introws.length; i++) {
                    //console.log(self.introws[i].interval_type.value); return;
                    if (self.introws[i].interval_type != null) {
                            if (self.introws[i].interval_type.value == "d" || self.introws[i].interval_type.value == "n") {
                                self.requireFrom = 'require';
                                this.requireTo = 'require';
                                this.requireUOM = '';
                            } else if (self.introws[i].interval_type.value == "m") {
                                this.requireFrom = 'require';
                                this.requireTo = 'require';
                                this.requireUOM = 'require';
                            } else if (self.introws[i].interval_type.value == "o") {
                                this.requireFrom = '';
                                this.requireTo = '';
                                this.requireUOM = '';
                            }
                    }
                }
            },
            createProgram(flag) {
                var self = this;
                var error = false;

                var typeCheckArr = [];
                var vehicle_id = [];
                var group_id = [];
                var data = this.$refs['listProgramAssetTable'].selectedRows;
                for (var i = 0;i < data.length;i++) {
                    if (data[i] != undefined) {
                        if (data[i] != null) {
                            if (data[i].vehicle_id != undefined && data[i].vehicle_id != null) {
                                vehicle_id.push(data[i].vehicle_id);
                            }
                            if (data[i].group_id != undefined && data[i].group_id != null) {
                                group_id.push(data[i].group_id);
                            }
                        }
                    }
                }

                for (var i = 0; i < self.introws.length; i++) {
                    self.introws[i].interval_type_error_msg = "";
                    self.introws[i].from_value_error = "";
                    self.introws[i].to_value_error = "";
                    self.introws[i].uom_error = "";

                    if (typeCheckArr.includes(self.introws[i].interval_type.value)){
                        self.introws[i].interval_type_error_msg = "Cannot use same interval twice";
                        error = true;
                    }
                    if (self.introws[i].interval_type == null || self.introws[i].interval_type == '' || !self.introws[i].interval_type) {
                        self.introws[i].interval_type_error_msg = "Interval Type is Required.";
                        error = true;
                    }
                    typeCheckArr.push(self.introws[i].interval_type.value);
                    if (self.introws[i].interval_type != null && self.introws[i].interval_type != '' && self.introws[i].interval_type.value && self.introws[i].interval_type.value != 'o') {

                        if (self.introws[i].from_value == null || self.introws[i].from_value == ''){
                            self.introws[i].from_value_error = "From Value is Required.";
                            error = true;
                        }

                        if (self.introws[i].to_value == null || self.introws[i].to_value == ''){
                            self.introws[i].to_value_error = "To Value is Required.";
                            error = true;
                        }

                    }
                    if (self.introws[i].interval_type != null && self.introws[i].interval_type != '' && self.introws[i].interval_type.value && self.introws[i].interval_type.value == 'm') {

                        if (self.introws[i].uom_id == null || self.introws[i].uom_id == ''){
                            self.introws[i].uom_error = "UOM Required.";
                            error = true;
                        }
                    }
                }
            if (!error){

                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    if (segments[3])
                    {
                        $("#createProgramBtn").val("Updating ...");
                        $("#createProgramBtn").prop("disabled", true);
                        $("#cancelProgramBtn").prop("disabled",true);
                    } else {
                            $("#createProgramBtn").val("Saving ...");
                            $("#createProgramBtn").prop("disabled", true);
                            $("#cancelProgramBtn").prop("disabled",true);

                    }

                var fields = $("#programForm").serializeArray();

                    fields.push({
                        name: "items",
                        value: JSON.stringify(self.introws)
                    });
                    fields.push({
                        name: "vehicle_id",
                        value: JSON.stringify(vehicle_id)
                    });
                    fields.push({
                        name: "group_id",
                        value: JSON.stringify(group_id)
                    });

                    if (segments[3]){
                        fields.push({
                            name: "id",
                            value: segments[3]
                        });
                    }else{
                        fields.push({
                            name: "id",
                            value: 0
                        });
                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/programinterval/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {

                            self.loading = false;
                            if (segments[3])
                            {
                                $("#createProgramBtn").val("Update");
                                $("#createProgramBtn").prop("disabled", false);
                                $("#cancelProgramBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#").val("Save and Continue");
                                    $("#createProgramBtn").prop("disabled", false);
                                    $("#cancelProgramBtn").prop("disabled",false);

                                }else{

                                    $("#createProgramBtn").val("Save");
                                    $("#createProgramBtn").prop("disabled", false);
                                    $("#cancelProgramBtn").prop("disabled",false);

                                }
                            }
                            if (data.status == "success") {

                                if (flag == "Save and Continue") {

                                    self.hours = "";
                                    self.introws = [];
                                    $("#program-interval-modal").modal("hide");
                                }else{
                                    $("#program-interval-modal").modal("hide");
                                    self.introws = [];
                                }

                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#program-interval-modal").modal("hide");
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                            self.loadList();
                        },
                        error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3])
                            {
                                $("#createProgramBtn").val("Update");
                                $("#createProgramBtn").prop("disabled", false);
                                $("#cancelProgramBtn").prop("disabled",false);
                            } else {

                                    $("#createProgramBtn").val("Save");
                                    $("#createProgramBtn").prop("disabled", false);
                                    $("#cancelProgramBtn").prop("disabled",false);
                            }
                            self.generateStatusCodeMessage(jqXHR,true,'program-interval-create')
                        }
                    });

            }else{
                    self.errorValidationFocus();
            }

            },
            loadPrograms() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;


                var vehicle_id = [];
                var group_id = [];
                var data = this.$refs['listProgramAssetTable'].selectedRows;
                if (data.length > 1){
                    // self.$swal('','Select Only One Asset','info');
                    $("#program-interval-modal").modal("show");
                    self.introws.push({
                                        interval_id:0,
                                        interval_type: '',
                                        interval_type_error_msg:'',
                                        from_value: '',
                                        to_value:'',
                                        from_value_error:'',
                                        to_value_error:'',
                                        uom_error:'',
                                        uom_id:'',
                                        metric:'',
                                    });
                }else{
                    $("#program-interval-modal").modal("show");

                    for (var i = 0;i < data.length;i++) {
                        if (data[i] != undefined) {
                            if (data[i] != null) {
                                if (data[i].vehicle_id != undefined && data[i].vehicle_id != null) {
                                    vehicle_id.push(data[i].vehicle_id);
                                }
                                if (data[i].group_id != undefined && data[i].group_id != null) {
                                    group_id.push(data[i].group_id);
                                }
                            }
                        }
                    }
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/programinterval/" + segments[3],
                        type: "GET",
                        headers: this.ajxHeaders,
                        data: {
                            vehicle_id: vehicle_id,group_id : group_id
                        },
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                var arrData = data.content.row;
                                if (arrData){
                                    for (var i = 0; i < arrData.length; i++){
                                        var intervalType = '';
                                        for(var l =0;l < self.intervalTypeArr.length;l++){
                                            if (self.intervalTypeArr[l].value == arrData[i].interval_type){
                                                intervalType = {text:self.intervalTypeArr[l].text,value:arrData[i].interval_type};
                                            }
                                        }
                                        self.introws.push({
                                            interval_id:arrData[i].interval_id,
                                            interval_type:intervalType,
                                            interval_type_error_msg:'',
                                            from_value: arrData[i].from_value,
                                            to_value:arrData[i].to_value,
                                            uom_id:(arrData[i].uom_id != '')?arrData[i].uom:'',
                                            from_value_error:'',
                                            to_value_error:'',
                                            uom_error:'',
                                            metric:'',
                                        })

                                        self.onChangeUOM('',arrData[i].uom,i);
                                    }
                                }else{
                                    self.introws.push({
                                        interval_id:0,
                                        interval_type: '',
                                        interval_type_error_msg:'',
                                        from_value: '',
                                        to_value:'',
                                        from_value_error:'',
                                        to_value_error:'',
                                        uom_error:'',
                                        uom_id:'',
                                        metric:'',
                                    });
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'program-interval-load-by-id')
                        }
                    });
                }
            },
            hideModal(){
                var self = this;
                $("#program-interval-modal").modal("hide");
                self.introws = [];
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ProgramAssetMapperList.vue